<template>
	<aside :class="[settings.classes.wrapper]" aria-label="weitere Informationen">
		<slot />
	</aside>
</template>

<script setup>
import {defineSettings} from '../composables/component';
const settings = defineSettings('NkSidebar');
</script>
